import axios from '../request';

export default {
  getDashboardData: async () => {
    const response = await axios.post('/Api/Dashboard/dashboardIndex', {days: 30});
    return response.data;
  },
};
